<template>
  <div class="footer">
    <p class="mobile">
      Copyright ©高僑文教機構.All right reserved. <br />
      Design by Towdot.
    </p>
    <div class="row desktop">
      <div class="column">
        <h4 class="school">南屯校</h4>
        <div class="location">台中市南屯區河南路四段538號</div>
        <div class="phone">04 2389-2887</div>
      </div>
      <div class="column">
        <h4 class="school">西區校國小部</h4>
        <div class="location">台中市西區三民路一段169號</div>
        <div class="phone">04 2375-8082</div>
      </div>
      <div class="column">
        <h4 class="school">西區校國中部</h4>
        <div class="location">台中市西區三民路一段172-6號</div>
        <div class="phone">04 2229-9399</div>
      </div>
      <div class="column">
        <h4 class="school">西區校高中部</h4>
        <div class="location">台中市西區三民路一段166-2號</div>
        <div class="phone">04 2225-1089</div>
      </div>
      <div class="column">
        <h4 class="school">西屯校</h4>
        <div class="location">台中市西屯區上安路41號</div>
        <div class="phone">04 2700-3389</div>
      </div>
    </div>
    <div class="row social">
      <div class="column">
        <a target="_blank" :href="facebookUrl">
          <img alt="facebook" src="../assets/fb-btn-grey.svg" />
        </a>
      </div>
      <div class="column">
        <a target="_blank" href="https://line.me/R/ti/p/%40bzh1686u">
          <img alt="line" src="../assets/line-btn-grey.svg" />
        </a>
      </div>
    </div>
    <div class="privacy-policy">
      <router-link :to="{ name: 'PrivacyPolicy' }">隱私權政策</router-link>
    </div>
    <div class="hint">建議使用Chrome以達到最佳瀏覽體驗</div>
  </div>
</template>

<script>
export default {
  computed: {
    facebookUrl() {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        return "fb://page/?id=572806189534034";
      } else if (/(Android)/i.test(navigator.userAgent)) {
        return "fb://page/572806189534034";
      } else {
        return "https://www.facebook.com/kaochiao23892887/";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.footer {
  background: transparent url("../assets/footer-bg.png") bottom center no-repeat;
  background-size: 1200px auto;
  height: 274px;
  padding: 94px 0 10px 0;
  box-sizing: border-box;
  margin-top: -94px;

  .privacy-policy {
    display: flex;
    justify-content: center;
    a {
      color: white;
    }
  }

  .row {
    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: space-around;

    .column {
      color: white;
      font-weight: bold;

      .school {
        font-size: 14px;
        margin: 0 0 15px;
      }

      .location,
      .phone {
        font-size: 12px;
        margin-bottom: 8px;
      }
    }

    &.social {
      justify-content: center;
      margin-top: 27px 0 17px;

      .column {
        margin: 0 16px;
      }
    }
  }

  .hint {
    color: white;
    text-align: center;
  }
}

@media (max-width: 1023px) {
  p.mobile {
    color: white;
    font-size: 12px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 20px;
  }
}
</style>
